// Improved CSV parser that properly handles multiline content within quoted fields
export function parseCSVMax(text) {
    const result = [];
    let currentRow = [];
    let currentField = '';
    let inQuotes = false;
    let i = 0;

    while (i < text.length) {
    const char = text[i];
    const nextChar = text[i + 1];

    if (char === '"') {
        if (inQuotes && nextChar === '"') {
        // Handle escaped quotes ("")
        currentField += '"';
        i += 2;
        } else {
        // Toggle quote state
        inQuotes = !inQuotes;
        i++;
        }
    } else if (char === ',' && !inQuotes) {
        // Field separator found outside quotes
        currentRow.push(currentField.trim());
        currentField = '';
        i++;
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
        // End of row found outside quotes
        currentRow.push(currentField.trim());
        if (currentRow.length > 0) {
        result.push(currentRow);
        }
        currentRow = [];
        currentField = '';

        // Skip \r\n or \n\r combinations
        if (
        (char === '\r' && nextChar === '\n') ||
        (char === '\n' && nextChar === '\r')
        ) {
        i += 2;
        } else {
        i++;
        }
    } else {
        // Regular character or newline within quotes
        currentField += char;
        i++;
    }
    }

    // Handle the last field and row
    if (currentField || currentRow.length > 0) {
    currentRow.push(currentField.trim());
    result.push(currentRow);
    }

    // Filter out empty rows
    return result.filter(row => row.some(cell => cell.length > 0));
}

export const rowsToCSV = (rows) => {
  return rows
    .map(row =>
      row
        .map(value => {
          const v = String(value ?? '');
          if (v.includes('"') || v.includes(',') || v.includes('\n')) {
            return `"${v.replace(/"/g, '""')}"`;
          }
          return v;
        })
        .join(',')
    )
    .join('\n');
};